import { isArray, noop } from '@rehaje/shared'

import { ObserveSetEvent } from './event'
import { REACTIVE } from './flags'
import { reaction } from './reactions'

import type {
  ObserveOptions,
  Observer,
  ObserverWithOptions,
  ReactionOptions,
  Reactive
} from './types'
import type { Callback } from '@rehaje/shared'

export function observe(
  target: () => any,
  observer: Observer,
  options?: ObserveOptions & ReactionOptions
): Callback

export function observe(
  target: any,
  observer: Observer,
  options?: ObserveOptions
): Callback

export function observe(
  target: any,
  observer: Observer,
  options?: ObserveOptions
): Callback {
  if (typeof target === 'object')
    return observeObject(target, observer, options)
  if (typeof target === 'function')
    return observeCallback(target, observer, options)
  return noop
}
function observeCallback(
  callback: Callback<Reactive>,
  observer: Observer,
  options?: ObserveOptions & ReactionOptions
): Callback {
  let observeDispose = noop

  const reactionDispose = reaction(
    callback,
    (value: Reactive, oldValue: Reactive) => {
      if (value?.__rr_flags & REACTIVE) {
        observeDispose()
        observer(new ObserveSetEvent(oldValue, undefined, value))
        observeDispose = observeObject(value, observer, options)
      }
    },
    options
  )

  return () => {
    reactionDispose()
    observeDispose()
  }
}
function observeObject(
  object: Reactive,
  observer: ObserverWithOptions,
  options?: ObserveOptions
): Callback {
  if (!(object?.__rr_flags & REACTIVE)) return noop

  observer.async = options?.async ?? true
  observer.origin = options?.origin

  object.__rr_observers ??= []
  const observers = object.__rr_observers

  if (!isArray(observers) || observers.includes(observer)) return noop
  else if (options?.priority === 'high') observers.unshift(observer)
  else observers.push(observer)

  return () => observers.splice(observers.indexOf(observer), 1)
}
